import { useEffect, useRef } from 'react';
import { GoogleOneTapTrigger } from './GoogleOneTapManager';
import { loginMachine, useLoginStore } from '../auth/loginMachine';

export default function SmartSignIn() {
  const ui = useLoginStore((state) => state.ui);
  const oneTapAttemptRef = useRef(0);

  const isQuickPrompt = ui.kind === 'QuickLoginPromptPending';
  const reason = ui.kind === 'Idle' ? 'manual' : ui.reason;

  useEffect(() => {
    if (isQuickPrompt) {
      oneTapAttemptRef.current += 1;
    }
  }, [isQuickPrompt, reason]);

  useEffect(() => {
    if (!isQuickPrompt) return undefined;

    const timeoutId = window.setTimeout(() => {
      const latest = useLoginStore.getState().ui;
      if (latest.kind === 'QuickLoginPromptPending' && latest.reason === reason) {
        loginMachine.dispatch({ type: 'QuickLoginFailed', reason });
      }
    }, 3500);

    return () => window.clearTimeout(timeoutId);
  }, [isQuickPrompt, reason]);

  return (
    <>
      {isQuickPrompt && (
        <GoogleOneTapTrigger
          key={`${reason}-${oneTapAttemptRef.current}`}
          autoShow={true}
          delay={300}
          reason={reason}
          onSuccess={() => loginMachine.closePrompt()}
          onError={() => loginMachine.dispatch({ type: 'QuickLoginFailed', reason })}
          onNotDisplayed={() => loginMachine.dispatch({ type: 'QuickLoginFailed', reason })}
          onDismissed={() => loginMachine.dispatch({ type: 'QuickLoginFailed', reason })}
          disabled={!isQuickPrompt}
        />
      )}
    </>
  );
}
